import React, { useState } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";

//Common
import { LoadingIndicator } from "../../common/VFX-UI";

//App
import { queryKeys } from "../constants";

import { EmailTemplateContextData, TemplateEmailUseState } from "../../../types/template";
import { ContainerContentProps } from "../../../types";
import templateApi from "../../../app/model/api/templateApi";
import TemplateEmail from "./TemplateEmail";
import { organizationApi } from "../../../app/model/api";
import { EMPTY_GUID } from "../../../utility/constants";


export const TemplateEmailContext =
    React.createContext<EmailTemplateContextData | null>(null);

const TemplateEmailContainer: React.FC<ContainerContentProps> = (props) => {
    const [state, setState] = useState<TemplateEmailUseState>({
        templateId: null,
    });

    const templateEmailsGridQuery = useQuery({
        queryKey: [queryKeys.getEmailTemplates],
        queryFn: () =>
            templateApi.getEmailTemplates({
                parentId: null,
                isActive: true,
            }),
    });

    const emtailTemplateQuery = useQuery({
        queryKey: [queryKeys.getEmailTemplate, state.templateId],
        queryFn: () => templateApi.getEmailTemplate(state.templateId ?? EMPTY_GUID),
        enabled: state.templateId !== null,
    });

    const updateTemplateId = async (templateId: string | null) => {
        setState((prevState) => ({
            ...prevState,
            templateId: templateId,
        }));
    };

    const { mutate: deleteMutation } = useMutation<void, Error, string>({
        mutationFn: async (value: string) => {
            await organizationApi.deactivateEmployee(value);
        },
    });

    //const { mutate: activateMutation } = useMutation<void, Error, string>({
    //    mutationFn: async (value: string) => {
    //        await organizationApi.activateEmployee(value);
    //    },
    //});

    const contextValue: any = {
        data: emtailTemplateQuery?.data?.result,
        id: state.templateId,
        setId: updateTemplateId,
        refetchGrid: () => templateEmailsGridQuery?.refetch(),
    };

    if (templateEmailsGridQuery?.isLoading) return <LoadingIndicator />;

    return (
        <TemplateEmailContext.Provider value={contextValue}>
            <TemplateEmail
                data={templateEmailsGridQuery?.data?.result}
                deleteMutation={deleteMutation}
                fullscreen={props?.fullscreen}
            />
        </TemplateEmailContext.Provider>
    );
};

export default TemplateEmailContainer;
